import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { GRADES } from "@/data";

export default function Catalog() {
  const scrollTo = () => document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section data-testid="grades" id="grades" className="dark bg-black text-[#F5F4EF] py-28 md:py-40 grain relative">
      <div className="relative z-10 mx-auto max-w-[1600px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-6 border-t border-white/20 pt-6"
        >
          <div>
            <span className="font-mono-accent text-xs uppercase tracking-[0.25em] text-signal-yellow">
              /02 — Grades
            </span>
            <h2 className="font-display mt-6 text-4xl md:text-6xl tracking-tighter">
              M10 to M70. <span className="text-primary">Batched to spec.</span>
            </h2>
          </div>
          <p className="max-w-sm text-muted-foreground text-base leading-relaxed">
            Every grade is proportioned, slump-tested and delivered fresh. Custom design mixes available on request.
          </p>
        </motion.div>

        <div className="border-l border-t border-white/15">
          {GRADES.map((g, i) => (
            <motion.button
              key={g.code}
              data-testid={`grade-row-${g.code}`}
              onClick={scrollTo}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="w-full text-left grid grid-cols-12 items-center gap-4 border-b border-r border-white/15 px-6 py-8 hover:bg-primary hover:text-white transition-colors group"
            >
              <span className="col-span-4 md:col-span-2 font-display text-4xl md:text-5xl tracking-tighter">
                {g.code}
              </span>
              <span className="col-span-8 md:col-span-2 font-mono-accent text-sm uppercase tracking-[0.15em] text-signal-yellow group-hover:text-white">
                {g.strength}
              </span>
              <span className="col-span-9 md:col-span-6 text-base text-[#F5F4EF]/70 group-hover:text-white">
                {g.use}
              </span>
              <span className="col-span-3 md:col-span-2 flex items-center justify-end gap-2 font-mono-accent text-xs uppercase tracking-[0.15em]">
                <span className="hidden md:inline">{g.tag}</span>
                <ArrowUpRight size={20} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
              </span>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
